export const getSecureBrowserError = state => state.secureBrowserError;
export const getVerifiedAccessKioskError = state => state.verifiedAccessKioskError;
